import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from '../../../../core/services/notification.service';
import { UserService } from '../../../../core/services/user.service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxPaginationModule,
    LoadingComponent,
    SampleSearchPipe,
    StatusComponent
  ],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css'
})
export class NotificationComponent {
  buttonsPermission: any | undefined;
  data: any[] = [];
  users: any[] = [];
  selected_data: any;
  selectedUserId: any;
  loading = false;
  loading2 = false;
  tag = "Notifications";
  search_text = "";
  pg = {
    pageSize: 10,
    p: 0,
    total: 0
  }

  constructor(
    private notificationService: NotificationService,
    private userService: UserService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private lsService: LocalStorageService,
    private modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init() {
    this.getAll()
    this.getUsers()
  }

  getAll() {
    this.loading2 = true
    this.notificationService.getAll().subscribe((res: any) => {
      this.data = res.data
      this.pg.pageSize = 10
      this.pg.p = 0
      this.pg.total = res.data.length
      this.modalService.dismissAll()
      this.loading2 = false
    },
      (err: any) => {
        this.loading2 = false
        AppErrorShow.showError("Gestion des notifications", err)
      })
  }

  getUsers() {
    this.userService.getAll().subscribe((res: any) => {
      this.users = res.data
    },
      (err: any) => {
        AppErrorShow.showError("Gestion des notifications", err)
      })
  }

  notifyUser(value: any) {
    this.loading = true
    this.notificationService.store({
      target: this.selectedUserId,
      title: value.title,
      content: value.content,
      type: 'both',
      status: 'unread',
      payload: {},
      is_push: true,
      is_deletable: true
    }).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAll()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion des notifications", err)
      })
  }

  notifyAll(value: any) {
    this.loading = true
    this.notificationService.store({
      target: 0,
      title: value.title,
      content: value.content,
      type: 'both',
      status: 'unread',
      payload: {},
      is_push: true,
      is_deletable: true
    }).subscribe((res: any) => {
      this.loading = false
      this.toastrService.success(res.message)
      this.getAll()
    },
      (err: any) => {
        this.loading = false
        AppErrorShow.showError("Gestion des notifications", err)
      })
  }

  delete() {
    if (!this.verifyIfElementChecked()) return;
    let confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.notificationService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message)
          this.getAll()
        },
          (err: any) => {
            AppErrorShow.showError("Gestion des notifications", err)
          })
      }
    })
  }

  deleteAll() {
    let confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez vous vraiment supprimer toutes les notifications ?',);
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.loading2 = true
        this.notificationService.deleteAll().subscribe((res: any) => {
          this.loading2 = false
          this.toastrService.success(res.message)
          this.getAll()
        },
          (err: any) => {
            this.loading2 = false
            AppErrorShow.showError("Gestion des notifications", err)
          })
      }
    })
  }

  checked(el?: any) {
    this.selected_data = el;
  }

  verifyIfElementChecked() {
    if (this.selected_data == null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }

  notifyOne(content: any) {
    this.selectedUserId = null;
    this.modalService.open(content, { size: 'lg' });
  }

  notifyEveryone(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() {
    this.modalService.dismissAll()
  }

  getActions() {
    this.buttonsPermission = {
      add: AppActionCheck.check(this.tag, 'Ajouter'),
      delete: AppActionCheck.check(this.tag, 'Supprimer')
    };
  }

  getPage(event: any) {
    this.pg.p = event
  }
}
